import type { BannerRootData } from '../schemas/bannerSchema';
import { BannerSlot } from '../types/bannerManagement';

export interface BannerUploadImageItem {
  formFieldPath: string;
  uploadKey: string;
  label: string;
  file: File;
}

interface BannerImageValue {
  file?: unknown;
}

const isFile = (value: unknown): value is File => value instanceof File;

export function buildBannerImageUploadItems(
  data: BannerRootData
): BannerUploadImageItem[] {
  const images = data.content.images;
  const slot = data.configuration.slotType;

  if (slot === BannerSlot.Top) {
    const topImageConfig: Array<{
      value: BannerImageValue | undefined;
      uploadKey: string;
      label: string;
      formFieldPath: string;
    }> = [
      {
        value: images.web,
        uploadKey: 'web',
        label: 'imagem Web',
        formFieldPath: 'content.images.web',
      },
      {
        value: images.tablet,
        uploadKey: 'tablet',
        label: 'imagem Tablet',
        formFieldPath: 'content.images.tablet',
      },
      {
        value: images.mobile,
        uploadKey: 'mobile',
        label: 'imagem Mobile',
        formFieldPath: 'content.images.mobile',
      },
    ];

    return topImageConfig
      .filter(item => isFile(item.value?.file))
      .map(item => ({
        file: item.value?.file as File,
        uploadKey: item.uploadKey,
        label: item.label,
        formFieldPath: item.formFieldPath,
      }));
  }

  const singleImageFile = images.single?.file;

  if (!isFile(singleImageFile)) {
    return [];
  }

  const uploadKey =
    slot === BannerSlot.Middle
      ? 'middle'
      : slot === BannerSlot.Bottom
        ? 'bottom'
        : 'middle';

  return [
    {
      file: singleImageFile,
      uploadKey,
      label: 'imagem do banner',
      formFieldPath: 'content.images.single',
    },
  ];
}
